import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import PageHeader from '../../Components/PageHeader/PageHeader';

const KnowledgeRepositoryDetails = () => {
    const location = useLocation()
    const { state } = location
    return (
        <>
            <PageHeader
                title="Knowledge Repository"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    { label: 'Knowledge Repository', href: '/knowledgeRepository' },
                    { label: state?.title }
                ]}
            />

            <div className="container pb-5 pt-5" >
                <h2 className="mb-5">{state?.title}</h2>

                <img
                    src={`https://api.coeupdspadelhi.in/uploads/${state?.image}`}
                    className="card-img-top"
                    alt={state?.title}
                />

                {
                    state?.img_creit &&
                    <Link to={state?.img_creit}>
                        <p className='text-primary'
                            style={{
                                textAlign: 'right'
                            }}
                        >Image Credit Goes To</p>
                    </Link>
                }

                <p className="mt-5">
                    {state?.description}
                </p>

            </div>

        </>
    );
};

export default KnowledgeRepositoryDetails;